
import { GenericSuspense, LeftSidebar, useRuntimeEnv, useTranslation } from "@bsm/component";
import { Outlet } from "react-router-dom";

const AuthLayout = () => {

    const { runtimeEnv } = useRuntimeEnv()
    const t = useTranslation()

    return (
        <div className="grid min-h-svh lg:grid-cols-2">
            <GenericSuspense>
                <Outlet />
            </GenericSuspense>
        </div>
    )
}

export default AuthLayout;
